export default __webpack_public_path__ + "static/media/12.e4a5b2fc.jpg";